import { render, staticRenderFns } from "./firmNotification.vue?vue&type=template&id=6bfdac2c&scoped=true&"
import script from "./firmNotification.vue?vue&type=script&lang=js&"
export * from "./firmNotification.vue?vue&type=script&lang=js&"
import style0 from "./firmNotification.vue?vue&type=style&index=0&id=6bfdac2c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfdac2c",
  null
  
)

export default component.exports